import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { validateTokenWithBackend } from "../../api/backend"; // Adjust the import path as

export function TokenJoinScreen({ 
  onJoinWithToken, 
  onBackToNormalFlow 
}) {
  const [tokenInput, setTokenInput] = useState("");
  const [roomIdInput, setRoomIdInput] = useState("");
  const [participantName, setParticipantName] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleJoinWithToken = async () => {
    if (!tokenInput.trim() || !roomIdInput.trim() || !participantName.trim()) {
      toast.error("Please fill in all fields");
      return;
    }

    setIsLoading(true);
    try {
    //   Validate token with your FastAPI backend (optional)
      const validation = await validateTokenWithBackend(tokenInput, roomIdInput);
      
      onJoinWithToken({
        token: tokenInput.trim(),
        roomId: roomIdInput.trim(),
        participantName: participantName.trim()
      });
    } catch (error) {
      toast.error("Invalid token or room ID");
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0">
      <div className="overflow-y-auto flex flex-col flex-1 h-screen bg-gray-800">
        <div className="flex flex-1 flex-col items-center justify-center p-6">
          <div className="w-full max-w-md bg-gray-750 rounded-lg p-6">
            <h2 className="text-2xl font-bold text-white text-center mb-6">
              Join with Token
            </h2>
            
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Join Token
                </label>
                <input
                  type="text"
                  value={tokenInput}
                  onChange={(e) => setTokenInput(e.target.value)}
                  placeholder="Enter your join token"
                  className="w-full px-4 py-3 bg-gray-650 rounded-xl text-white border border-gray-600 focus:border-purple-350 focus:outline-none"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Room ID
                </label>
                <input
                  type="text"
                  value={roomIdInput}
                  onChange={(e) => setRoomIdInput(e.target.value)}
                  placeholder="Enter room ID"
                  className="w-full px-4 py-3 bg-gray-650 rounded-xl text-white border border-gray-600 focus:border-purple-350 focus:outline-none"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Your Name
                </label>
                <input
                  type="text"
                  value={participantName}
                  onChange={(e) => setParticipantName(e.target.value)}
                  placeholder="Enter your name"
                  className="w-full px-4 py-3 bg-gray-650 rounded-xl text-white border border-gray-600 focus:border-purple-350 focus:outline-none"
                />
              </div>
              
              <button
                onClick={handleJoinWithToken}
                disabled={isLoading}
                className={`w-full py-3 rounded-xl font-medium ${
                  isLoading 
                    ? "bg-gray-650 text-gray-400 cursor-not-allowed" 
                    : "bg-purple-350 text-white hover:bg-purple-400"
                }`}
              >
                {isLoading ? "Joining..." : "Join Meeting"}
              </button>
              
              <button
                onClick={onBackToNormalFlow}
                className="w-full py-3 rounded-xl font-medium bg-gray-650 text-white hover:bg-gray-600"
              >
                Back to Normal Join
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
